<template>
  <b-modal
    id="edit-user-details-modal"
    ref="editUserDetailsModalRef"
    size="lg"
    title="Editar detalhes do usuário"
    @ok="handleOk"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div style="display: flex; gap: 2rem; width: 100%;">
        <PhoneInput v-model="userDetailsForm.phone" />
        <EmailInput style="width: 100%;" v-model="userDetailsForm.email" />
      </div>
    </form>
  </b-modal>
</template>

<script>
/// <reference path="../types/index.js" />
import { PhoneInput, EmailInput } from '../../../ui/inputs';
import { Api } from '../../../vue/api';
const API = new Api();

export default {
  name: 'EditUserDetailsModal',
  components: {
    PhoneInput,
    EmailInput,
  },
  data() {
    return {
      /**
       * @type {UserDetailsForm}
       */
      userDetailsForm: {
        id: null,
        phone: '',
        email: '',
      },
    };
  },
  methods: {
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      await this.handleSubmit();
    },
    openModal(user) {
      this.userDetailsForm = user;
      this.$refs.editUserDetailsModalRef.show();
    },
    async handleSubmit() {
      for (const field of Object.values(this.userDetailsForm)) {
        if (!field) {
          this.$bvToast.toast('Preencha todos os campos!', {
            title: `Erro`,
            variant: 'error',
            solid: true,
          });
          return;
        }
      }
      const { id, phone, email } = this.userDetailsForm;
      const { errors, ok } = await API.post('/execute', {
        path: `/user/change-phone-and-email/${id}`,
        method: 'post',
        data: { phone: `55${phone}`, email },
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        this.$refs.editUserDetailsModalRef.hide('edit-user-details-modal');
        return;
      }
      this.$bvToast.toast('Dados do usuário atualizado com sucesso!', {
        title: `Sucesso`,
        variant: 'success',
        solid: true,
      });
      this.$emit('getAll');
      this.$refs.editUserDetailsModalRef.hide('edit-user-details-modal');
    },
  },
};
</script>
